import type { GADataProps } from "@elements/GAData/GAData";
import type { MetaTagsProps } from "@elements/MetaTags/MetaTags";
import type { PageMetaDataValues } from "@typings/PageMetaData";

export default function HomeMetaData(): PageMetaDataValues {
  const gaData: GADataProps = {
    level2: "home",
    title: "home_index",
    contentcat: 1,
    contenttype: undefined,
  };

  const metaTags: MetaTagsProps = {
    title:
      "Tamil News, Latest Singapore, Tamilnadu & India News - Tamil Murasu, தமிழ் நியூஸ், தமிழ் செய்திகள், தமிழ் முரசு",
    description:
      "Tamil Murasu - Get Latest Singapore, Tamilnadu, India, World & Sports News in Tamil. சிங்கப்பூரின் ஒரே தமிழ் மொழி செய்தித்தாள். சிங்கப்பூர் செய்திகள், இந்தியா செய்திகள், தமிழ்நாடு செய்திகள், விளையாட்டு செய்திகள்.",
    slug: "",
  };

  return {
    gaData,
    metaTags,
  };
}
